module.exports = __webpack_public_path__ + "static/media/BCR Banner_RightAlign.ef60456a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BCR Banner_RightAlign.png
// module id = 462
// module chunks = 0